/**
 * The practice island's seed, `sha256("practice 16")`, the same for everyone
 * (#134).
 *
 * In a module of its own because two chunks want it: the practice shore,
 * loaded when the shore is taken, and the landing (#136), which draws the
 * same island as its illustration so a returning visitor recognises it. A
 * constant the landing imported from `practice.ts` would pull the whole
 * shore into the first load.
 */
export const PRACTICE_SEED_HEX = '26f53012195be412ca4027069e7421ed55121ca5558264e7586736cc75f83c6e'
